<div class="content message-position" role="main">
  <h1>404</h1>
  <div>
    <h2>{{'CP_LM_LANDINGPAGE_NOTFOUND' | customTranslation: translationData}}</h2>
  </div>
</div>
